function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useMemo, useRef } from 'react';
import { ScrollShadowBox } from '@arc/frontend/ui-layout';
import { su, theme } from '@arc/frontend/ui-theme';
import { useRect, useWindowViewHeight } from '@arc/frontend/util-common';
import { Modal } from './Modal';
const styles = {
  modalDialogOverride: {
    padding: '1.25rem',
    backgroundColor: theme.colors.background.form,
    boxShadow: '0px 4px 16px 0px gray'
  },
  modalHeader: /*#__PURE__*/css(su.text2xl, {
    color: theme.colors.text.primary,
    flex: '1 1 auto',
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    margin: '0px',
    fontWeight: '700'
  }, process.env.NODE_ENV === "production" ? "" : ";label:modalHeader;"),
  modalBody: process.env.NODE_ENV === "production" ? {
    name: "lxyb4p",
    styles: "flex:1 1 auto;padding-bottom:0.75rem;margin:0px"
  } : {
    name: "14wfsib-modalBody",
    styles: "flex:1 1 auto;padding-bottom:0.75rem;margin:0px;label:modalBody;",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  modalFooter: /*#__PURE__*/css({
    paddingLeft: '1.25rem',
    paddingRight: '1.25rem',
    paddingTop: '0.5rem',
    paddingBottom: '0.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '1 1 auto',
    margin: '0px',
    '& > :not(:first-of-type)': process.env.NODE_ENV === "production" ? {
      name: "10kuhi4",
      styles: "margin-left:1.25rem"
    } : {
      name: "1e4m3hw------not--first-of-type-",
      styles: "margin-left:1.25rem;label:-----not--first-of-type-;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:modalFooter;")
};
function ModalWithLayoutContent(props) {
  const {
    header,
    headerStyle,
    body,
    bodyStyle,
    footer,
    footerStyle,
    noScrollAreaPadding,
    leftOffset,
    topOffset
  } = props;
  const windowHeight = useWindowViewHeight();
  const containerRef = useRef(null);
  const containerHeight = useRect(containerRef)?.height;
  const headerRef = useRef(null);
  const headerHeight = useRect(headerRef)?.height;
  const footerRef = useRef(null);
  const footerHeight = useRect(footerRef)?.height;
  const bodyHeightStyle = useMemo(() => {
    if (containerHeight === undefined || headerHeight === undefined || footerHeight === undefined) {
      return;
    }
    const limit = windowHeight - 40;

    // Sometimes the container height is 1px less than the limit, this
    // causes a infinite loop resizing the container. So we add 1px
    // and round up the container height to prevent this.
    if (Math.ceil(containerHeight) + 1 >= limit) {
      return `${limit - headerHeight - footerHeight}px`;
    }
    return 'auto';
  }, [containerHeight, footerHeight, headerHeight, windowHeight]);
  return <div ref={containerRef} data-testid="modal-layout-content">
			<div css={[styles.modalHeader, headerStyle, process.env.NODE_ENV === "production" ? "" : ";label:ModalWithLayoutContent;"]} ref={headerRef}>
				{header}
			</div>
			<ScrollShadowBox height={bodyHeightStyle} scrollAreaStyle={[noScrollAreaPadding ? undefined : {
      paddingLeft: '1.25rem',
      paddingRight: '1.25rem'
    }, bodyStyle]} leftOffset={leftOffset ?? 0} topOffset={topOffset ?? 0}>
				{body}
			</ScrollShadowBox>
			<div css={footer ? [styles.modalFooter, footerStyle] : undefined} ref={footerRef} data-testid="modal-footer">
				{footer}
			</div>
		</div>;
}
export function ModalWithLayout(props) {
  const {
    header,
    headerStyle,
    body,
    bodyStyle,
    footer,
    footerStyle,
    noScrollAreaPadding,
    leftOffset,
    topOffset,
    ...modalProps
  } = props;
  return <Modal {...modalProps} dialogStyleOverrides={[modalProps.dialogStyleOverrides, {
    padding: '0'
  }]}>
			<ModalWithLayoutContent header={header} headerStyle={headerStyle} body={body} bodyStyle={bodyStyle} footer={footer} footerStyle={footerStyle} noScrollAreaPadding={noScrollAreaPadding} leftOffset={leftOffset} topOffset={topOffset} />
		</Modal>;
}